<template>
	<span :class="iconClasses" class="listing-item-icon"></span>
</template>

<script>
// Renders subtype icons on residential listing cards and detail pages.
export default {
	props: {
		type: {
			type: String,
			default: 'RES'
		},
		subType: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: null
		},
		size: {
			type: String,
			default: 'm'
		}
	},
	data() { 
		return {
			types: {
				'townhouse': {
					defaultColor: 'text-red500',
					icon: 'townhouse',
				},
				'apartment': {
					defaultColor: 'text-red500',
					icon: 'townhouse',
				},
				'condominium': {
					defaultColor: 'text-purple500',
					icon: 'condo',
				},
				'RES': {
					defaultColor: 'text-red500',
					icon: 'single-family',
				},
				'RNT': {
					defaultColor: 'text-red500',
					icon: 'single-family',
				},
				'MLF': {
					defaultColor: 'text-blue500',
					icon: 'multifamily',
				},
				'CRE': {
					defaultColor: 'text-gray500',
					icon: 'commercial',
				},
				'LND': {
					defaultColor: 'text-green500',
					icon: 'land',
				},
			}
		}
	},
	computed: {
		iconClasses() {

			var iconClasses = ''
			var typeAbbreviation = this.type
			var subType = String(this.subType).toLowerCase()

			var type = this.types[subType] || this.types[typeAbbreviation] || this.types.RES

			// Set the color
			if (this.color) {
				iconClasses += this.color + ' '
			} else {
				iconClasses += type.defaultColor + ' '
			}

			// Define the size and icon
			iconClasses += 'icon-' + this.size + '-' + type.icon

			return iconClasses

		}
	}
};
</script>
